import React from "react";
import Navbar from "./Navbar";


function TelecallerHome() {
    return(
        <>
        <Navbar />
        <div className="card" style={{backgroundColor:'gainsboro',position:'relative',top:'50px'}}>
            <h2 >Telecaller Home</h2>
        </div>
        </>
    );
}
export default TelecallerHome;